export const extractLastFrameAsBase64 = async (videoUrl: string): Promise<string> => {
  const response = await fetch(videoUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch video: ${response.status}`);
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  return new Promise<string>((resolve, reject) => {
    const tempVideo = document.createElement("video");
    tempVideo.muted = true;
    tempVideo.playsInline = true;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      URL.revokeObjectURL(blobUrl);
      reject(new Error("Could not get canvas context"));
      return;
    }

    const cleanup = () => {
      try {
        tempVideo.remove();
        canvas.remove();
        URL.revokeObjectURL(blobUrl);
      } catch {
        // ignore cleanup errors
      }
    };

    tempVideo.onloadedmetadata = () => {
      canvas.width = tempVideo.videoWidth;
      canvas.height = tempVideo.videoHeight;

      const targetTime = Math.max(0, tempVideo.duration - 0.5);
      tempVideo.currentTime = targetTime;
    };

    tempVideo.onseeked = () => {
      try {
        ctx.drawImage(tempVideo, 0, 0, canvas.width, canvas.height);
        const base64 = canvas.toDataURL("image/jpeg", 0.9);
        cleanup();
        resolve(base64);
      } catch (err) {
        cleanup();
        reject(err instanceof Error ? err : new Error("Failed to extract frame"));
      }
    };

    tempVideo.onerror = () => {
      cleanup();
      reject(new Error("Failed to load video"));
    };

    setTimeout(() => {
      cleanup();
      reject(new Error("Video loading timeout"));
    }, 10000);

    tempVideo.src = blobUrl;
  });
};
